module.exports = __webpack_public_path__ + "img/image-map-around-b47ae3b7.png";